import { DrilloutMethodBase } from './base/drillout-method-base';

export class DrilloutMethod extends DrilloutMethodBase { }